import { Component } from 'react';
import GoFetch from '~/js/modules/fetch-wrapper';
import Spinner from '~/js/components/general/Spinner';
import MainView from '~/js/components/liv-plus/MainView';
import DetailsView from '~/js/components/liv-plus/DetailsView';
import categoriesData from '~/js/components/liv-plus/data/categories';
// import eventsDataMocks from '~/js/components/liv-plus/data/events';

const fetch = new GoFetch();

class LivPlusContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      eventsData: [],
      isEventsLoading: true
    };
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate() {
    if (this.state.eventDetails) {
      window.addEventListener('popstate', this.backClickedHandler);
    } else {
      window.removeEventListener('popstate', this.backClickedHandler);
    }
  }

  getData = () => {
    fetch.post('/events/fetchLivPlus/')
      .then((response) => {
        const eventId = this.getQueryParams('eventId');
        const eventsWichShouldBeMerge = [9396, 9399];
        const objEvent = {};
        const { events } = response.data;
        
        //clean duplicate values
        const eventTmp = new Map(
          events.map(c => [c.eventId, c])
        );

        let eventsNew = [...eventTmp.values()];

        // events = eventsDataMocks;

        // I didn't want to do this, but these are management requirements.
        eventsNew = eventsNew.filter((el) => {
          if ((el.eventId === 9556) && (el.rstCode === 'SNG')) {
            return false;
          }

          if (el.eventId === 9397) {
            if ((el.rstCode === 'BRP' || el.rstCode === 'BBO')) {
              return false;
            }

            el.customRstInfo = 'Sandals Golf & Country Club';
          }

          if (eventsWichShouldBeMerge.includes(el.eventId)) {
            if (objEvent.hasOwnProperty(el.eventId)) {
              const { rstCode } = objEvent[el.eventId];

              rstCode.push ?
                rstCode.push(el.rstCode) :
                objEvent[el.eventId].rstCode = [rstCode, el.rstCode];

              if (Array.isArray(rstCode)) {
                if (rstCode.length === 3) {
                  objEvent[el.eventId].resortInfo = 'All Beaches Resorts';
                }
                if (rstCode.length === 16) {
                  objEvent[el.eventId].resortInfo = 'All Sandals Resorts';
                }
              }
            } else {
              objEvent[el.eventId] = el;
            }

            return false;
          }

          return true;
        });

        // events = [ ...Object.values(objEvent), ...events];
        eventsNew = [
          ...eventsNew.slice(0, 3),
          Object.values(objEvent)[0],
          ...eventsNew.slice(8, 9),
          ...eventsNew.slice(3, 7),
          Object.values(objEvent)[1],
          ...eventsNew.slice(7, 8),
          ...eventsNew.slice(10),
        ];

        this.setState({
          eventDetails: eventId && eventsNew.filter(el => el.eventId === +eventId)[0],
          eventsData: eventsNew.filter(el => el),
          isEventsLoading: false
        });
      })
      .catch(() => {
        this.setState({ eventsData: [], isEventsLoading: false });
      });
  }

  learMoreHandler = (event) => {
    this.prevTopScroll = window.scrollY;
    this.setQueryParams(event.eventId, 'eventId');

    window.scrollTo(0, 0);

    this.setState({ eventDetails: event });
  }

  setQueryParams = (value, key = 'section') => {
    const state = { [key]: value };

    let uri = window.location.pathname;

    if (value) {
      uri = `?${$.param(state)}`;
    }

    window.history.pushState(state, null, uri);
  }

  getQueryParams = (name) => {
    const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

    return results && (results[1] || null);
  }

  tabHandler = (tab) => {
    if (tab.type === 'all') {
      this.setState({ tabChecked: null }, this.setQueryParams(null));
    } else {
      this.setState({ tabChecked: tab }, this.setQueryParams(tab.type));
    }
  }

  backClickedHandler = () => {
    this.setState({ eventDetails: null });

    if (this.state.tabChecked) {
      this.setQueryParams(this.state.tabChecked.type);
    } else {
      this.setQueryParams(null);
    }
  }

  scrollToPrevItem = () => {
    this.prevTopScroll && window.scrollTo(0, this.prevTopScroll);
  }

  setDefaultSection = () => {
    const section = this.getQueryParams('section');

    if (section) {
      const currentCategory = categoriesData.find((el) => el.type === section);

      currentCategory && this.setState({ tabChecked: currentCategory });
    }
  }

  renderView = () => {
    const { eventsData, eventDetails, tabChecked, isEventsLoading } = this.state;
    const eventId = this.getQueryParams('eventId');

    let filtredEventsData = eventsData;

    if (tabChecked) {
      filtredEventsData = eventsData.filter((el) => el.groupName.toLowerCase() === tabChecked.type);
    }

    let view = (
      <MainView
        events={filtredEventsData}
        tabChecked={tabChecked}
        loading={isEventsLoading}
        tabHandler={this.tabHandler}
        learMoreHandler={this.learMoreHandler}
        initialTopScroll={this.scrollToPrevItem}
        setDefaultSection={this.setDefaultSection} />
    );

    if (eventId) {
      view = <Spinner />;
    }

    if (eventDetails) {
      view = <DetailsView data={eventDetails} onBackClicked={this.backClickedHandler} />;
    }

    return view;
  }

  render() {
    return this.renderView();
  }
}

export default LivPlusContainer;
